export class ExternalApps {
    initialize = (config) => {
        this.config = config;
    };

    getAppInfo(appName) {

        // If client app is portal oidc or va oidc, it is not an external app and the myblock config can be used.
        if (appName === "PORTALOIDC" || appName === "VAOIDC") {
            return null;
        }

        if(appName === "RTE")
        {
            return {
                clientId: this.config.rte.clientId,
                baseUrl: this.config.rte.baseUri,
                callbackUrl: this.getCallbackUrl(this.config.rte.baseUri)
            }
        }
        
        var app = this.config.diy.apps[appName];
        const unSupportedDiy = ['DIY16','DIY17','DIY18'];
        if (unSupportedDiy.includes(appName)) {
            return {
                clientId: null,
                baseUrl: app.baseUri,
                callbackUrl: null
            }
        }
        return {
            clientId: this.config.diy.clientId,
            baseUrl: app.baseUri,
            callbackUrl: app.baseUri
        }
    }

    getSupportedDiyApps() {
        var diyApps = Object.entries(this.config.diy.apps).map(([appName, app]) => {
            return {
                appName: appName,
                taxYear: app.taxYear,
            };
        }).sort((a, b) => b.taxYear - a.taxYear);
        return diyApps;
    }

    getCallbackUrl(baseUrl) {
        return `${baseUrl}/callback`;
    }
}

const externalApps = new ExternalApps();
export default externalApps;

